import { render, staticRenderFns } from "./AppFormCheckbox.vue?vue&type=template&id=66594b9c&scoped=true&"
import script from "./AppFormCheckbox.vue?vue&type=script&lang=ts&"
export * from "./AppFormCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./AppFormCheckbox.vue?vue&type=style&index=0&id=66594b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66594b9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
